import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { LaborItemService } from '@fs/services/labor-item';
import { TabOpenService } from '@services/tab-open.service';
import { PermissionPipe } from '@shared/pipes/permission';
import { ActionName } from '@shared/enums/action-name';
import { Tabs } from '@enums/tab.enum';
import { Constants } from '@shared/models/constants';
import { NotificationsService } from '@shared/services/notification';
import { AuthService } from '@services/auth.service';
import { CommonMethods } from '@services/common.method';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { ProductItemType } from '@fs/enums/common-enums';

@Component({
  selector: 'labor-item-detail',
  templateUrl: './labor-detail.component.html',
  styleUrls: ['./labor-detail.component.scss']
})
export class LaborItemDetailComponent implements OnInit {

  //#region Variable Declarations
  details: any;
  actionName = ActionName;
  inputParams: any;
  tabCounter: number;
  defaultLaborImage: string = Constants.DefaultImagePaths.Labour;
  qbVersion: string = "";
  productItemType = ProductItemType;
  //#endregion

  //#region Constructor
  constructor(
    private laborItemService: LaborItemService,
    private toastr: NotificationsService,
    private permissionPipe: PermissionPipe,
    private auth: AuthService,
    private tabOpen: TabOpenService,
    private showspinner: SpinnerService,
    private viewContainerRef: ViewContainerRef) {
      this.qbVersion = (this.auth.getCompanyQBType()).toLowerCase();
  }
  //#endregion

  //#region Lifecycle Events
  ngOnInit() {
    this.getLaborItem(Constants.defaultSpinnertimeout);
  }
  //#endregion

  //#region Methods
  refreshTab() {
    this.getLaborItem();
  }
  openEditLaborItem() {
    if (!this.permissionPipe.transform(ActionName.EditItem)) {
      return
    }
    this.tabOpen.ReplaceTab(
      {
        CurrentTabIndex: this.tabCounter,
        newTabInfo: {
          tabId: Tabs.FsLiteLaborItemEdit,
          params: { ID: this.inputParams.ID },
          tabTitle: 'Labor - ' + this.details.ItemNumber
        }
      });
  }
  private getLaborItem(spinnerTimeout: number = 0) {
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter, spinnerTimeout);
    this.laborItemService.GetLaborItem({ params: this.inputParams }
    ).subscribe(
      response => {

        this.details = response;
        if (!CommonMethods.CheckNullOrUndefined(this.details.Category.FullName)){
               this.details.Category.FullName = this.details.Category.FullName.replace(/\//g, ':'); 
        }
        
        if (!CommonMethods.CheckNullOrUndefined(this.details)) {
          this.details.PriceBookItem = {
            IsFrequentlyUsed: this.details.IsFrequentlyUsed,
            IsTaxable: this.details.IsTaxable,
            IsDescriptionEditAllowed: this.details.IsDescriptionEditAllowed,
            IsPriceEditAllowed: this.details.IsPriceEditAllowed,
            IsAgreementExcluded: this.details.IsAgreementExcluded
          };
        }
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
      }, error => {
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        this.toastr.showMultiLineError(error.error.Message, "Error");
      });
  }
  //#endregion
}